<template>
 <div>
  <EditSolarSubProduct ref="editSolarSubProductRef"/>
  <TableStyleWrapper>
   <TableWrapper class="table-responsive">
    <a-table
     :columns="productTableColumns"
     :dataSource="productTableData"
     :loading="loadingSolarSubProducts"
     :pagination="{
          pageSize: tablePageSize,
          showSizeChanger: true,
          total: count,
          current: currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${count} items`,
        }"
     @change="paginationChange"
    />
   </TableWrapper>
  </TableStyleWrapper>
 </div>
</template>
<script>
import {TableStyleWrapper} from '../style';
import {TableWrapper} from '../../styled';
import {computed, defineComponent, ref} from 'vue';
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import EditSolarSubProduct from "@/view/product/component/EditSolarSubProduct";
import {useAbility} from "@casl/vue";

const productTableColumns = [
 {
  title: 'ID',
  dataIndex: 'id',
  key: 'id',
 },
 {
  title: 'Naam',
  dataIndex: 'name',
  key: 'name',
 },
 {
  title: 'Bedrag',
  dataIndex: 'price',
  key: 'price',
 },
 {
  title: 'Maximale Wattpiek',
  dataIndex: 'maxWattPeak',
  key: 'maxWattPeak',
 },
 {
  title: 'Min panelen',
  dataIndex: 'minPanelCount',
  key: 'minPanelCount',
 },
 {
  title: 'Max panelen',
  dataIndex: 'maxPanelCount',
  key: 'maxPanelCount',
 },
 {
  title: 'Status',
  dataIndex: 'active',
  key: 'active',
 },
 {
  title: 'Actions',
  dataIndex: 'action',
  key: 'action',
  width: '90px',
 },
];
const SolarProductsTable = defineComponent({
 name: 'SolarProductsTable',
 components: {TableStyleWrapper, TableWrapper, EditSolarSubProduct},
 setup() {
  const {state, dispatch} = useStore();
  const tablePageSize = computed(() => state.solarSubProduct.pageSize);
  const {params} = useRoute();
  const editSolarSubProductRef = ref();
  const {can} = useAbility();
  const loadingSolarSubProducts = computed(() => state.solarSubProduct.loadingSolarSubProducts);
  const productsSubProducts = computed(() => state.solarSubProduct.solarSubProducts);
  const currentPage = computed(() => state.solarSubProduct.currentPage);
  const count = computed(() => state.solarSubProduct.count);
  const handleDelete = (id) => {
   dispatch('deleteSolarSubProduct', {id: id, productID: params.id});
  };
  const productTableData = computed(() => {
    return productsSubProducts.value.map((product) => {
     const {id, name, imageFileURL, price, active, wattPeak, maxWattPeak, maxPanelCount, minPanelCount} = product;

     return {
      key: id,
      id: id,
      name: (
       <div class="user-info">
        <figure>
         {imageFileURL && imageFileURL !== '' ? (
          <img style={{width: '40px'}} src={`${imageFileURL}`} alt=""/>
         ) : (
          <img style={{width: '40px'}} src={require('@/static/img/users/1.png')} alt=""/>
         )}
        </figure>
        <figcaption>
         <sdHeading class="user-name" as="h6">
          {name}
         </sdHeading>
        </figcaption>
       </div>
      ),
      wattPeak: <span>{wattPeak}</span>,
      maxWattPeak: <span>{maxWattPeak}</span>,
      minPanelCount: <span>{minPanelCount}</span>,
      maxPanelCount: <span>{maxPanelCount}</span>,
      price: <span>{new Intl.NumberFormat('nl-nl', {style: 'currency', currency: 'EUR'}).format(price)}</span>,
      active: (<span className="status-text" style={{
       color: 'white',
       backgroundColor: active ? '#0CAB7C' : '#E30D0F'
      }}>{active ? 'Actief' : 'Inactief'}</span>),
      action: (
       <div className="table-actions">
        <sdButton onClick={() => editSolarSubProductRef.value.showDrawer(id)} className="btn-icon" to="#" type="default"
                  shape="circle">
         <sdFeatherIcons type="edit" size="16"/>
        </sdButton>
        {can('delete', 'product') ? (
         <a-popconfirm
          title="Weet je het zeker? U kunt dit niet meer terugdraaien!"
          ok-text="Ja"
          cancel-text="Nee"
          placement="leftTop"
          onConfirm={() => handleDelete(id)}
         >
          <sdButton className="btn-icon" type="default" to="#" shape="circle">
           <sdFeatherIcons type="trash-2" size="16"/>
          </sdButton>
         </a-popconfirm>
        ) : ('')}
       </div>
      ),
     };
    })
   }
  );

  const paginationChange = async (event) => {
   await dispatch('setCurrentPageSolarSubProduct', event.current);
   await dispatch('getSolarSubProducts', {productID: params.id, page: event.current, pageSize: event.pageSize});
  }

  return {tablePageSize,
   productTableColumns,
   productTableData,
   loadingSolarSubProducts,
   paginationChange,
   state,
   productsSubProducts,
   editSolarSubProductRef,
   currentPage,
   count,
  };
 },
});

export default SolarProductsTable;
</script>
